import axiosClient from './axiosClient';

export const notificationsApi = {
  /*
   * Return the latest global database notifications
   * for the authenticated user.
   */
  getNotifications() {
    return axiosClient.get(
      '/notifications',
    );
  },

  /*
   * Return only the unread count.
   */
  getUnreadCount() {
    return axiosClient.get(
      '/notifications/unread-count',
    );
  },

  /*
   * Mark one notification as read.
   */
  markRead(notificationId) {
    return axiosClient.post(
      `/notifications/${notificationId}/read`,
    );
  },

  /*
   * Mark all authenticated-user notifications as read.
   */
  markAllRead() {
    return axiosClient.post(
      '/notifications/read-all',
    );
  },
};

export default notificationsApi;